import { type Observable, distinctUntilChanged, map } from 'rxjs'
import { shareLatest } from '@/utils/rx-util'
import { mediaQueryMatchStream } from '@/utils/browser-util'

/**
 * Color schemes.
 */
export type ColorScheme = 'light' | 'dark'

/**
 * An observable that emits whether the system prefers light mode or dark mode.
 */
export const systemColorSchemePreference$: Observable<ColorScheme> =
  mediaQueryMatchStream('(prefers-color-scheme: dark)').pipe(
    distinctUntilChanged(),
    map((prefersDark): ColorScheme => (prefersDark ? 'dark' : 'light')),
    shareLatest(),
  )

/**
 * Sets the color scheme on the document.
 *
 * @param scheme
 */
export function setColorScheme(scheme: ColorScheme) {
  document.documentElement.setAttribute('data-theme', scheme)
}
